import isDesktopUserAgent from './isDesktopUserAgent';

export const EVENT_TEAM_LIMIT = 32;
export const IMAGE_UPLOAD_TIMEOUT = 30000;
export const INITIAL_CHAT_LIMIT = 100;
export const MAXIMUM_EVENT_TEAM_COUNT = 32;
export const MAXIMUM_EVENT_TITLE_LENGTH = 64;
export const MINIMUM_EVENT_TITLE_LENGTH = 3;
export const MAXIMUM_PERSON_TEAM_COUNT = 32;
export const MAXIMUM_TEAM_TITLE_LENGTH = 32;
export const DEFAULT_SEARCH_MINIMUM = 1;
export const LONG_PRESS_DELAY = 250;
export const CLICK_OR_TAP = isDesktopUserAgent ? 'click' : 'tap';
